import { useEffect, useState } from "react";

import SmallLoading from "@/components/shared/smallLoading";
import { Rptproblems, TaskRptFinal, TaskRpts } from "@/types/owner/task/v2task";
import { useProblemMemo } from "@/hooks/owner/task/useProblemMemo";

import type { MemoData } from "@/types/owner/task/memo";

type Props = {
  memoData: MemoData[];
  taskrpt?: TaskRpts;
  tasksubrptCommentsId?: number;
  rptproblem?: Rptproblems;
  taskrptFinal?: TaskRptFinal;
};

/* 異常箇所メモの入力 */
const ProblemMemoInput: React.FC<Props> = ({
  memoData,
  taskrpt,
  tasksubrptCommentsId,
  rptproblem,
  taskrptFinal
}) => {
  const [defaultMemo, setDefaultMemo] = useState("");
  const {
    isLoading,
    isSaveLoading,
    setTargetTaskrpt,
    setTasksubrptCommentsId,
    setInputMemo,
    setTargetRptProblem,
    setTargetTaskrptFinal
  } = useProblemMemo();

  //各データをセット
  const dataSet = () => {
    if (taskrpt) setTargetTaskrpt(taskrpt);
    if (tasksubrptCommentsId) setTasksubrptCommentsId(tasksubrptCommentsId);
    if (rptproblem) setTargetRptProblem(rptproblem);
    if (taskrptFinal) setTargetTaskrptFinal(taskrptFinal);
  };

  // メモの保存処理
  const memoSaveHandler = (e: React.FocusEvent<HTMLTextAreaElement>) => {
    dataSet();
    setInputMemo(e.target.value);
  };

  // メモの初期値（保存されているメモ）をセット
  useEffect(() => {
    if (
      memoData.length > 0 &&
      (tasksubrptCommentsId || rptproblem) &&
      !defaultMemo
    ) {
      const commentId =
        tasksubrptCommentsId || rptproblem?.problem_comment?.problem_comment_id;
      const memoText = memoData.filter(
        (data) => data.problem_comment_id === commentId
      )[0]?.comment;
      setDefaultMemo(memoText || "");
    }
  }, [memoData, tasksubrptCommentsId, rptproblem]);

  return (
    <div className="relative">
      <textarea
        className="h-[10rem] w-full rounded-md border border-cBorderGray p-16 text-md focus:border-cselected"
        placeholder="メモを入力"
        defaultValue={defaultMemo}
        onBlur={memoSaveHandler}
        disabled={isLoading || isSaveLoading}
        maxLength={200}
      />
      {(isLoading || isSaveLoading) && (
        <div className="absolute -bottom-5 right-[0.5rem]">
          <SmallLoading />
        </div>
      )}
    </div>
  );
};

export default ProblemMemoInput;
